<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  inject: ['setLoading'],
  components: {
    Vue3ChartJs,
  },
  data() {
    return {
      errors: {},
      title: "Reports",
      text: "Quotation Detailed Report",
      text1: "Reports",
      isCollapsed: false,
      app_currency: '',
      filter: {
        user: '',
        from_date: '',
        to_date: '',
      },
      users: [],
      data: [],
      total_amount: 0,
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
      selectedColumns: [],
    };
  },

  computed: {
   serialNo() {
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   },
    
   columnGroups() {
    return [
      {
        label: 'Basic Info',
        columns: [
          { key: 'id', label: 'ID' },
          { key: 'quotation_number', label: 'Quotation No' },
          { key: 'quotation_date', label: 'Quotation Date' },
          { key: 'valid_until', label: 'Valid Until' },
          { key: 'subject', label: 'Subject' },
          { key: 'summary', label: 'Summary' },
          { key: 'terms', label: 'Terms' },
          { key: 'notes', label: 'Notes' }
        ]
      },
      {
        label: 'Financial',
        columns: [
          { key: 'status', label: 'Status' },
          { key: 'tax_mode', label: 'Tax Mode' },
          { key: 'subtotal', label: 'Subtotal' },
          { key: 'tax_amount', label: 'Tax Amount' },
          { key: 'discount', label: 'Discount' },
          { key: 'transportation_cost', label: 'Transportation Cost' },
          { key: 'installation_cost', label: 'Installation Cost' },
          { key: 'total', label: 'Total' }
        ]
      },
      {
        label: 'Parties',
        columns: [
          { key: 'assigned_to', label: 'Assigned To' },
          { key: 'created_by', label: 'Created By' },
          { key: 'to_name', label: 'Client Name' },
          { key: 'to_email', label: 'Client Email' },
          { key: 'to_phone', label: 'Client Phone' },
          { key: 'to_address', label: 'Client Address' },
          { key: 'to_pincode', label: 'Client Pincode' },
          { key: 'to_city', label: 'Client City' },
          { key: 'to_state', label: 'Client State' },
          { key: 'to_country', label: 'Client Country' }
        ]
      },
      {
        label: 'Advanced',
        columns: [
          { key: 'created_at', label: 'Created At' },
          { key: 'items', label: 'Items Summary (Multi-line)' }
        ]
      }
    ];
   }
  },

  async mounted() {
   this.getUsers();
   this.app_currency = await this.$appCurrency();

   const start = moment().subtract(1, "month");
   const end = moment();

   new DateRangePicker(
    this.$refs.dateRangeInput,
    {
     startDate: start,
     endDate: end,
      locale: {
        format: "DD/MM/YYYY",
        separator: " - "
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      }
     },
     (start, end) => {
      this.setDateRange(start, end);
     },
     this.booking_range
    );
    
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);

    //LOAD DATA
    this.filterReport();
  },

  methods: {
   booking_range(start, end) {
    return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
   },

   setDateRange(start, end) {
    this.filter.from_date = start.format("YYYY-MM-DD");
    this.filter.to_date = end.format("YYYY-MM-DD");
   },

   async filterReport(page = 1) {
    this.errors = {};
    this.setLoading(true);
    try {
      const payload = {
        page,
        user_id: this.filter.user,
        from_date: this.filter.from_date,
        to_date: this.filter.to_date
      };
      const query_string = new URLSearchParams(payload).toString(); 
      const response = await axios.get(`/reports/quotation/detailed?${query_string}`);
      this.data = response.data.data.quotations.data;
        
      this.pagination = {
       current_page: response.data.data.quotations.current_page,
       per_page: response.data.data.quotations.per_page,
       last_page: response.data.data.quotations.last_page,
       total: response.data.data.quotations.total,
       links: response.data.data.quotations.links
      };

      this.total_amount = response.data.data.total_amount;

     }catch(error){
      if(error.type == 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.message, 'error');
      }
     }finally{
      this.setLoading(false);
     }
    },

    async getUsers() {
     this.setLoading(true);
     try{
      const response = await axios.get('/users/all-users');
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    /** Quick export - all columns (empty columns array) */
    async quickExport(format) {
     const payload = {
      user_id: this.filter.user,
      from_date: this.filter.from_date,
      to_date: this.filter.to_date,
     };
     await this.downloadExport(`/exports/quotations/${format}`, payload);
    },

    /** Custom columns export */
    async exportCustomColumns(format) {
     if(!this.selectedColumns.length){
      this.$swalToast('Please select at least one column', 'warning');
      return;
     }

     const payload = {
      user_id: this.filter.user,
      from_date: this.filter.from_date,
      to_date: this.filter.to_date,
      columns: this.selectedColumns
     }; 
     await this.downloadExport(`/exports/quotations/${format}`, payload);
    },

    /** Reusable download method */
    async downloadExport(url, payload) {
     this.setLoading(true);
     try {
      const response = await axios.post(url, payload, {
       responseType: 'blob',
      });

      const blob = new Blob([response.data], {
       type: response.headers['content-type'],
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      const format = url.split('/').pop(); // Extract format from URL
      let filename = `quotation_report_${this.$timeStamp()}.${format}`;
      const disposition = response.headers['content-disposition'];

      if(disposition && disposition.indexOf('filename=') !== -1){
       const filenameMatch = disposition.match(/filename="?(.+)"?/);
       if(filenameMatch && filenameMatch.length === 2){
        filename = filenameMatch[1];
       }
      }

      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      this.$swalToast('Export downloading...', 'success');
     }catch(error){
      console.error(error);
      this.$swalToast(error?.response?.data?.message || 'Export failed', 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url) {
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.filterReport(page);
    },

    clearFilter() {
      this.filter = {
        user: ''
      };
      this.filterReport();
    }
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <!-- Enhanced Export Dropdown -->
          <div class="me-2 mb-2" v-if="data?.length">
            <div class="dropdown">
              <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <!-- Quick Export -->
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="quickExport('csv')">
                    <i class="ti ti-file-type-csv me-1"></i>Export as CSV (All Columns)
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="quickExport('xlsx')">
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel (All Columns)
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                
                <!-- Custom Columns Export - Now uses Bootstrap modal trigger -->
                <li>
                  <a href="#columnSelectorModal" class="dropdown-item rounded-1" data-bs-toggle="modal" data-bs-target="#columnSelectorModal">
                    <i class="ti ti-columns-3 me-1"></i>Custom Columns...
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="row">
        <div class="col-lg-3">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between overflow-hidden mb-2">
                <!-- Left Side -->
                <div>
                  <h4><strong>{{app_currency.code}}</strong></h4>
                  <h5 class="mt-2">{{ total_amount }}</h5>
                  <p class="fs-12 fw-normal text-truncate mt-1">Total Quotation Amount</p>
                </div>

                <!-- Right Side -->
                <div class="text-end">
                  <span class="avatar rounded-circle bg-info mb-2">
                    <i class="ti ti-credit-card-pay fs-16"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-0">
        <div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
          <div class="d-flex align-items-center flex-wrap mb-1">
            <div class="me-3" v-if="filter.user !== '' ">
              <a href="javascript:void(0);" class="text-danger" @click="clearFilter()">
                <i class="ti ti-filter-x"></i>
              </a>
            </div> 

            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
                <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
              </div>
            </div>

            <div class="me-3">
              <select class="form-select" v-model="filter.user">
                <option value="">User</option>
                <option :value="row.id" v-for="row in users" :key="row.id">{{row.name}}</option>
              </select>
              <div class="text-danger small mt-1" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
            </div>

            <div class="me-3">
              <button type="button" class="btn btn-dark" @click="filterReport">
                <i class="ti ti-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="custom-datatable-filter table-responsive">
            <table class="table datatable thead-light" v-if="data?.length">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Quotation No</th>
                  <th>Subject</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Created By</th>
                  <th>Client Name</th>
                  <th>Client Company</th>
                  <th>Amount</th>
                  <th>Closure Probability</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in data" :key="row.id">
                  <td>{{ serialNo + index + 1 }}.</td>
                  <td>
                    <h6 class="fs-14 fw-medium"> 
                      <a :href="`/sales/quotations/view/${row.public_token}`" target="_blank">{{ row.quotation_number }}</a> 
                    </h6>
                  </td>
                  <td>
                    <h6 class="fs-14 fw-medium"> 
                      <a :href="`/sales/quotations/view/${row.public_token}`" target="_blank">{{ row.subject }}</a> 
                    </h6>
                  </td>
                  <td>{{ $formatDate(row.quotation_date) }}</td>
                  <td>{{ row.status }}</td>
                  <td>{{ row.created_by?.name }}</td>
                  <td>
                    <h6 class="fs-14 fw-medium"> 
                      <a :href="$partyURL(row.party_id, row.party_type)" target="_blank">{{ row.party?.name }}</a>
                    </h6>
                  </td>
                  <td>
                    <h6 class="fs-14 fw-medium"> 
                      <a :href="$partyURL(row.party_id, row.party_type)" target="_blank">{{ row.party?.company_name }}</a> 
                    </h6>
                  </td>
                  <td><b>{{row.party?.currency?.code}}</b> {{ row.total }}</td>
                  <td><span v-if="row.closure_probability">{{ row.closure_probability }}%</span></td>
                </tr>
              </tbody>
            </table>

            <div v-else class="p-3 text-center text-muted"> No records found.</div>

            <!-- Pagination -->
            <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
              <ul class="pagination pagination-sm">
                <li v-for="(link, index) in pagination.links" :key="index"
                  :class="['page-item', { active: link.active, disabled: !link.url }]">
                  <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
                </li>
              </ul>
            </nav>
          </div>
        </div>  
      </div>
    </div>

    <!-- Column Selector Modal - Now uses Bootstrap modal classes -->
  <div class="modal fade" id="columnSelectorModal" tabindex="-1" aria-labelledby="columnSelectorModalLabel" aria-hidden="true" ref="columnModal">
  <div class="modal-dialog modal-lg">
   <div class="modal-content">
    <div class="modal-header">
     <h5 class="modal-title" id="columnSelectorModalLabel">Select Export Columns</h5>
     <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
    <div class="row">
    <div class="col-md-6" v-for="group in columnGroups" :key="group.label">
     <h6 class="fw-bold mb-2">{{ group.label }}</h6>
     <div v-for="column in group.columns" :key="column.key" class="form-check mb-2">
      <input class="form-check-input" type="checkbox" :id="`col-${column.key}`" v-model="selectedColumns" :value="column.key">
      <label class="form-check-label" :for="`col-${column.key}`"> {{ column.label }} </label>
      </div>
      </div>
    </div>
    </div>
    <div class="modal-footer">
     <button type="button" class="btn btn-secondary me-2" data-bs-dismiss="modal">Cancel</button>
     <button type="button" class="btn btn-primary me-2" @click="exportCustomColumns('csv')" :disabled="!selectedColumns.length">Export CSV ({{ selectedColumns.length }} columns)</button>
     <button type="button" class="btn btn-success" @click="exportCustomColumns('xlsx')" :disabled="!selectedColumns.length">Export Excel ({{ selectedColumns.length }} columns)</button>
    </div>
    </div>
    </div>
    </div>

    <app-footer></app-footer>
  </div>
</template>
<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>